import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowRight, Building2, TrendingUp, PlusCircle } from 'lucide-react';
import NewsletterSignup from '../components/NewsletterSignup';

const Home = () => {
  const options = [
    {
      title: 'Bestehende GmbH kaufen',
      description:
        'Finde eine passende Bestands-GmbH und starte schneller mit einer bereits eingetragenen Gesellschaft.',
      icon: Building2,
      href: '/marktplatz',
      button: 'Zum Marktplatz',
      primary: false,
    },
    {
      title: 'GmbH zum Verkauf anbieten',
      description:
        'Reiche deine Bestands-GmbH diskret ein. Wir prüfen die bereitgestellten Angaben auf Plausibilität und bringen dich mit qualifizierten Interessenten zusammen.',
      icon: TrendingUp,
      href: '/seller-onboarding',
      button: 'Jetzt anbieten',
      primary: true,
    },
    {
      title: 'Neue GmbH gründen',
      description:
        'Starte direkt das Formular. Wir begleiten dich von der Vorbereitung bis zur Eintragung – strukturiert und transparent.',
      icon: PlusCircle,
      href: '/onboarding',
      button: 'Formular starten',
      primary: false,
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero */}
      <section className="pt-32 pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-[1320px] mx-auto">
          <div className="max-w-3xl mx-auto text-center">
            <p className="text-sm md:text-base font-semibold text-[#009E9A] tracking-wide uppercase mb-4">
              Unternehmensvermittlung
            </p>
            <h1 className="text-4xl md:text-5xl lg:text-[56px] font-bold text-[#0B1930] mb-6 leading-[1.1]">
              Kaufen. Verkaufen. Gründen.
            </h1>
            <p className="text-lg md:text-xl text-gray-600 mb-4 leading-relaxed max-w-2xl mx-auto">
              Ob Kauf, Verkauf oder Gründung – wir begleiten Dich persönlich und strukturiert bei Deinem Vorhaben.
            </p>
            <div className="flex items-center justify-center gap-6 text-sm md:text-base text-gray-500 mt-10 mb-14">
              <span>Diskrete Vermittlung</span>
              <span className="w-1.5 h-1.5 bg-[#009E9A] rounded-full"></span>
              <span>Persönliche Begleitung</span>
              <span className="w-1.5 h-1.5 bg-[#009E9A] rounded-full"></span>
              <span>Strukturierter Prozess</span>
            </div>
          </div>

          {/* 3 Geschäftsbereiche - weniger Card-Look, mehr typografische Struktur */}
          <div className="max-w-[1100px] mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-0 md:gap-0 border-t border-gray-200">
              {options.map((opt, index) => {
                const Icon = opt.icon;
                const isLast = index === options.length - 1;
                return (
                  <div
                    key={opt.title}
                    className={`py-8 md:py-10 px-6 md:px-8 flex flex-col ${!isLast ? 'border-b md:border-b-0 md:border-r border-gray-200' : ''}`}
                  >
                    <div className="flex items-center gap-3 mb-4">
                      <Icon className="w-5 h-5 text-[#009E9A]" />
                      <span className="text-xs font-semibold text-[#009E9A] uppercase tracking-wider">
                        {index === 0 ? 'Kaufen' : index === 1 ? 'Verkaufen' : 'Gründen'}
                      </span>
                    </div>
                    <h2 className="text-xl md:text-[22px] font-bold text-[#0B1930] mb-3 leading-tight">{opt.title}</h2>
                    <p className="text-[15px] md:text-base text-gray-600 leading-relaxed mb-6 flex-grow">{opt.description}</p>
                    <div className="mt-auto">
                      <Link to={opt.href}>
                        <Button
                          className={`justify-center rounded-lg text-[15px] px-5 py-2.5 ${
                            opt.primary
                              ? 'bg-[#0B1930] hover:bg-[#162844] text-white'
                              : 'bg-white border border-gray-300 text-[#0B1930] hover:bg-[#E9F7F6] hover:border-[#009E9A]'
                          }`}
                        >
                          {opt.button}
                          <ArrowRight className="ml-2 w-4 h-4" />
                        </Button>
                      </Link>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-[#E9F7F6]">
        <div className="max-w-[800px] mx-auto">
          <NewsletterSignup />
        </div>
      </section>

      {/* Kleine Kontakt-Alternative */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white border-t border-gray-100">
        <div className="max-w-[800px] mx-auto text-center">
          <p className="text-base md:text-lg text-gray-600 mb-6">
            Unsicher, welcher Weg der richtige ist? Schreib uns – wir helfen schnell weiter.
          </p>
          <Link to="/kontakt">
            <Button className="bg-[#0B1930] hover:bg-[#162844] text-white px-7 py-3 text-[15px] rounded-lg">
              Kontakt aufnehmen
              <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
